import mapValues from 'lodash/mapValues';

// The languages offered in every localization panel, in display order. Both
// LocalizationContainer and ContactLocalizationContainer carried an identical
// copy of this table before they were typed.
export const LOCALIZATION_LANGUAGES: Record<string, string> = {
  "fi": "Finnish",
  "en": "English",
  "sv": "Swedish",
  "bg": "Bulgarian",
  "de": "Germany",
  "es": "Spanish",
  "et": "Estonian",
  "fr": "French",
  "hu": "Hungarian",
  "it": "Italian",
  "ja": "Japanese",
  "ko": "Korean",
  "nl": "Dutch",
  "no": "Norwegian",
  "pl": "Polish",
  "ru": "Russian",
  "zh": "Chinese",
};

// Every language mapped to an empty string — the baseline a stored label object
// is merged onto, so each textarea always has a string value. Derived from the
// table above rather than being a second hand-maintained list that could drift.
export const EMPTY_LOCALIZATIONS: Record<string, string> =
  mapValues(LOCALIZATION_LANGUAGES, () => '');

// Taplause green marks a language that already has a translation; grey is empty.
export const FILLED_BACKGROUND = 'rgba(76, 169, 47, 1)';
export const EMPTY_BACKGROUND = 'rgba(150, 150, 150, 0.5)';
